@use "../../styles/breakpoint.module.scss" as *;

.accordion {
    composes: safeGridContainer from "../../styles/composable/layout.module.css";
}

.list {
    grid-column: 2 / span 10;
    border-top: 1px solid var(--color-contrast);

    @media ($below-tablet) {
        grid-column: 1 / -1;
    }
}
